import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "justify-start items-center inline-flex" }
const _hoisted_2 = { class: "self-stretch pl-1 py-1 justify-center items-center gap-2.5 flex" }
const _hoisted_3 = { class: "grow shrink basis-0 self-stretch px-3 justify-start items-center gap-3 flex" }
const _hoisted_4 = { class: "grow shrink basis-0 flex-col justify-start items-start gap-0.5 inline-flex" }
const _hoisted_5 = { class: "text-racq-dark-grey text-base-bold text-left line-clamp-1" }
const _hoisted_6 = { class: "text-racq-med-grey text-xs text-left line-clamp-2" }
const _hoisted_7 = { class: "justify-center items-center flex flex-col self-start py-4" }
const _hoisted_8 = {
  key: 0,
  class: "bg-icon-check icon w-3 h-2.5 bg-no-repeat bg-contain"
}

import { Image } from '@sitecore-jss/sitecore-jss-vue';
import { ImageField } from '@sitecore-jss/sitecore-jss-vue/types/components/Image';


export default /*@__PURE__*/_defineComponent({
  __name: 'RadioCardListExpandableItem',
  props: {
    label: {},
    help: {},
    image: {},
    isSelected: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.image?.value?.src)
        ? (_openBlock(), _createBlock(_unref(Image), {
            key: 0,
            media: _ctx.image,
            class: "w-[60px] rounded-sm"
          }, null, 8, ["media"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.label), 1),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.help), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          class: _normalizeClass(["w-5 h-5 rounded-full self-stretch justify-center items-center inline-flex", _ctx.isSelected ? 'bg-racq-blue-active' : 'border-2 border-racq-light-blue-grey'])
        }, [
          (_ctx.isSelected)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ])
  ]))
}
}

})